import { CnResult } from '@/components/cn-result';

export default CnResult;
